import { IConfigData } from '@df/catalog/config/config.interfaces';
import { App } from '@df/core/app';

declare global {
    interface Window {
        adobe?: {
            target?: Ab.IAdobeTargetApi;
        };
    }
}

export namespace Ab {
    export interface IOptions {
        convertcom?: {
            script: (app: App) => string;
        };
        googleOptimize?: {
            containerId: (app: App) => string;
        };
        adobeTarget?: {
            enabled: boolean;
        };
    }

    export interface IExperimentDef {
        key: string;
        backend?: boolean;
        engine?: TEngine;
        adobetarget_parameters?: IExperimentDefAdobetargetParameter[];
        adobetarget_variants?: IExperimentDefAdobetargetVariant[];
    }

    export interface IExperimentDefAdobetargetParameter {
        parameter_name: string;
        parameter_value: string;
    }

    export interface IExperimentDefAdobetargetVariant {
        variant_name: string;
    }

    export type TEngine = 'google' | 'convertcom' | 'adobetarget';

    export type TVariant = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';

    /**
     * Config entry id
     */
    export const configId = 'ab.setup';

    /**
     * Config model data
     */
    export interface IModelData extends IConfigData<Ab.IConfigContent> {}

    export interface IConfigContent {
        experiments: IExperimentDef[];
    }

    export interface IExperimentState {
        // selected variant
        variant: TVariant;

        // if variant state is initial or it was set from google
        isInitial: boolean;
        // if experiment is missing in 3rdparty data
        missing?: boolean;
    }

    export interface IExperimentStatusInfo {
        name: string;
        key: string;
        variant: Ab.TVariant | undefined;
        active: boolean;
        variants: Ab.TVariant[];
    }

    export interface IAdobeTargetApi {
        getOffers(data: IAdobeTargetGetOffersData): Promise<IAdobeTargetGetOffersResponse>;
    }

    export interface IAdobeTargetGetOffersData {
        consumerId?: string;
        decisioningMethod?: string;
        request: {
            execute: {
                pageLoad?: {
                    parameters?: { [key: string]: string };
                    profileParameters?: { [key: string]: string };
                };
            };
        };
        timeout?: number;
    }

    export interface IAdobeTargetGetOffersResponse {
        meta?: { decisioningMethod?: string };
        execute?: {
            pageLoad?: {
                options?: IAdobeTargetGetOffersResponseDetails[];
            };
        };
    }

    export interface IAdobeTargetGetOffersResponseDetails {
        type?: 'html' | 'json' | 'redirect' | 'dynamic' | 'actions';
        responseTokens?: IAdobeTargetGetOffersResponseDetailsResponseTokens;
    }

    export interface IAdobeTargetGetOffersResponseDetailsResponseTokens {
        'activity.id'?: string;
        'activity.name'?: string;
        'experience.name'?: string;
        'experience.id'?: string;
        'offer.id'?: string;
        'offer.name'?: string;
        'option.id'?: string;
        'option.name'?: string;
    }
}
